interface SelectChevronProps {
  className?: string;
}

export default function SelectChevron({ className = '' }: SelectChevronProps) {
  return (
    <i
      className={`ri-arrow-down-s-line pointer-events-none ${className}`}
      aria-hidden="true"
    />
  );
}